import { isFulfilled } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../app/hooks";
import { NameIdOption } from "../../../../../common/types/commonTypes";
import { fetchTrainingDefinitions } from "../../../../../features/talents/talentsSlice";
import i18n from "../../../../../i18n";

const useTrainingsAutocomplete = () => {
  const dispatch = useAppDispatch();
  const [trainingOptions, setTrainingOptions] = useState<NameIdOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(fetchTrainingDefinitions({})).then((action) => {
      if (isFulfilled(action)) {
        const locale = i18n.language.substring(0, 2);
        const options = action.payload.map((training) => {
          const name =
            training.localizedName[
              locale as keyof typeof training.localizedName
            ] ||
            training.localizedName.fi ||
            training.localizedName.en ||
            training.localizedName.sv ||
            training.id;
          return {
            id: training.id,
            name,
          };
        });
        setTrainingOptions(
          options.sort((a, b) => a.name.localeCompare(b.name, "fi")),
        );
      }
      setIsLoading(false);
    });
  }, [dispatch]);

  return {
    trainingOptions,
    isLoading,
  };
};

export default useTrainingsAutocomplete;
